// Approved vehicle tariffs in INR, excluding GST and the listed extras.
// Local base hire is for 120 KM / 12 hours, plus fuel. Outstation rates include fuel.
// fuelType and fuelKmPerLitre describe local fuel billing, not claimed vehicle mileage.
export const VEHICLE_TARIFFS = [
  {
    "id": "swift-dzire",
    "name": "Maruti Suzuki Dzire",
    "category": "Sedan",
    "preference": "Swift Dzire",
    "passengerSeats": 4,
    "driverSeats": 1,
    "totalSeats": 5,
    "localBaseFare": 1200,
    "extraHour": 100,
    "nightCharge": 500,
    "fuelType": "Petrol",
    "fuelKmPerLitre": 10,
    "outstationRatePerKm": 13
  },
  {
    "id": "etios",
    "name": "Toyota Etios",
    "category": "Sedan",
    "preference": "Toyota Etios",
    "passengerSeats": 4,
    "driverSeats": 1,
    "totalSeats": 5,
    "localBaseFare": 1200,
    "extraHour": 100,
    "nightCharge": 500,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 10,
    "outstationRatePerKm": 13
  },
  {
    "id": "brezza",
    "name": "Maruti Suzuki Brezza",
    "category": "SUV / MPV",
    "preference": "Maruti Brezza",
    "passengerSeats": 4,
    "driverSeats": 1,
    "totalSeats": 5,
    "localBaseFare": 1400,
    "extraHour": 120,
    "nightCharge": 500,
    "fuelType": "Petrol",
    "fuelKmPerLitre": 10,
    "outstationRatePerKm": 14
  },
  {
    "id": "ertiga",
    "name": "Maruti Suzuki Ertiga",
    "category": "SUV / MPV",
    "preference": "Maruti Ertiga",
    "passengerSeats": 6,
    "driverSeats": 1,
    "totalSeats": 7,
    "localBaseFare": 1800,
    "extraHour": 150,
    "nightCharge": 500,
    "fuelType": "Petrol",
    "fuelKmPerLitre": 10,
    "outstationRatePerKm": 15
  },
  {
    "id": "bolero",
    "name": "Mahindra Bolero",
    "category": "SUV / MPV",
    "preference": "Mahindra Bolero",
    "passengerSeats": 6,
    "driverSeats": 1,
    "totalSeats": 7,
    "localBaseFare": 1600,
    "extraHour": 140,
    "nightCharge": 500,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 10,
    "outstationRatePerKm": 15
  },
  {
    "id": "bolero-neo",
    "name": "Mahindra Bolero Neo",
    "category": "SUV / MPV",
    "preference": "Mahindra Bolero Neo",
    "passengerSeats": 6,
    "driverSeats": 1,
    "totalSeats": 7,
    "localBaseFare": 1800,
    "extraHour": 150,
    "nightCharge": 500,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 8,
    "outstationRatePerKm": 16
  },
  {
    "id": "scorpio",
    "name": "Mahindra Scorpio",
    "category": "SUV / MPV",
    "preference": "Mahindra Scorpio",
    "passengerSeats": 6,
    "driverSeats": 1,
    "totalSeats": 7,
    "localBaseFare": 2200,
    "extraHour": 190,
    "nightCharge": 500,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 8,
    "outstationRatePerKm": 18
  },
  {
    "id": "kia-carens",
    "name": "Kia Carens",
    "category": "SUV / MPV",
    "preference": "Kia Carens",
    "passengerSeats": 6,
    "driverSeats": 1,
    "totalSeats": 7,
    "localBaseFare": 2000,
    "extraHour": 170,
    "nightCharge": 500,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 10,
    "outstationRatePerKm": 17
  },
  {
    "id": "innova-crysta",
    "name": "Toyota Innova Crysta",
    "category": "SUV / MPV",
    "preference": "Toyota Innova Crysta",
    "passengerSeats": 6,
    "driverSeats": 1,
    "totalSeats": 7,
    "localBaseFare": 3000,
    "extraHour": 250,
    "nightCharge": 700,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 8,
    "outstationRatePerKm": 22
  },
  {
    "id": "force-trax-cruiser",
    "name": "Force Trax Cruiser",
    "category": "SUV / MPV",
    "preference": "Force Trax Cruiser",
    "passengerSeats": 12,
    "driverSeats": 1,
    "totalSeats": 13,
    "localBaseFare": 3500,
    "extraHour": 300,
    "nightCharge": 1000,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 6,
    "outstationRatePerKm": 27
  },
  {
    "id": "tempo-traveller-13",
    "name": "Tempo Traveller 13 Seater",
    "category": "Tempo Traveller",
    "preference": "13 seater",
    "passengerSeats": 12,
    "driverSeats": 1,
    "totalSeats": 13,
    "localBaseFare": 4500,
    "extraHour": 380,
    "nightCharge": 1000,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 6,
    "outstationRatePerKm": 40
  },
  {
    "id": "tempo-traveller-17",
    "name": "Tempo Traveller 17 Seater",
    "category": "Tempo Traveller",
    "preference": "17 seater",
    "passengerSeats": 16,
    "driverSeats": 1,
    "totalSeats": 17,
    "localBaseFare": 7000,
    "extraHour": 590,
    "nightCharge": 1000,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 6,
    "outstationRatePerKm": 45
  },
  {
    "id": "tempo-traveller-20",
    "name": "Tempo Traveller 20 Seater",
    "category": "Tempo Traveller",
    "preference": "20 seater",
    "passengerSeats": 19,
    "driverSeats": 1,
    "totalSeats": 20,
    "localBaseFare": 7500,
    "extraHour": 630,
    "nightCharge": 1500,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 6,
    "outstationRatePerKm": 48
  },
  {
    "id": "tempo-traveller-21",
    "name": "Tempo Traveller 21 Seater",
    "category": "Tempo Traveller",
    "preference": "21 seater",
    "passengerSeats": 20,
    "driverSeats": 1,
    "totalSeats": 21,
    "localBaseFare": 8000,
    "extraHour": 670,
    "nightCharge": 1500,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 6,
    "outstationRatePerKm": 50
  },
  {
    "id": "tempo-traveller-26",
    "name": "Tempo Traveller 26 Seater",
    "category": "Tempo Traveller",
    "preference": "26 seater",
    "passengerSeats": 25,
    "driverSeats": 1,
    "totalSeats": 26,
    "localBaseFare": 9000,
    "extraHour": 750,
    "nightCharge": 1500,
    "fuelType": "Diesel",
    "fuelKmPerLitre": 6,
    "outstationRatePerKm": 55
  }
];

export const TARIFF_POLICY = {
  "localKm": 120,
  "localHours": 12,
  "minFuelKm": 120,
  "outstationMinKmPerDay": 300,
  "gstPercent": 5,
  "garageToGarage": true,
  "driverIncluded": true,
  "extras": [
    "Driver meal",
    "Toll",
    "Parking",
    "Border charges",
    "Applicable night charges"
  ]
};

const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

export function formatINR(value) {
  return inrFormatter.format(value);
}

function normalizePreference(value) {
  return typeof value === "string"
    ? value.trim().toLowerCase().replace(/[-–—]/g, " ").replace(/\s+/g, " ")
    : "";
}

const tariffsByPreference = new Map();
for (const tariff of VEHICLE_TARIFFS) {
  const aliases = [tariff.preference, tariff.name];
  if (tariff.category === "Tempo Traveller") {
    aliases.push(
      `Tempo Traveller ${tariff.totalSeats} seater`,
      `${tariff.totalSeats} seater Tempo Traveller`
    );
  }
  for (const alias of aliases) {
    tariffsByPreference.set(normalizePreference(alias), tariff);
  }
}

// Unlisted choices, including 9-seater and old 12-seater labels, require a quote.
export function getVehicleTariff(preference) {
  return tariffsByPreference.get(normalizePreference(preference));
}
